export default __webpack_public_path__ + "static/media/factory__55.6a233e1e.jpg";